import { CNav, CNavItem, CNavLink, CTabContent, CTabPane } from "@coreui/react";
import { useState } from "react";
import UpdateDiscount from "../update";
import UsageDetails from "./UsageDetails";

export function CouponDetails() {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div>
      <CNav variant="tabs" className="mb-2">
        <CNavItem
          href="#couponInfo"
          active={activeTab === 0}
          onClick={() => setActiveTab(0)}
        >
          <CNavLink
            className={`${activeTab === 0 ? "text-danger" : "text-black"}`}
          >
            Détails des coupons
          </CNavLink>
        </CNavItem>

        <CNavItem
          href="#usage"
          active={activeTab === 1}
          onClick={() => setActiveTab(1)}
        >
          <CNavLink
            className={`${activeTab === 1 ? "text-danger" : "text-black"}`}
          >
            Utilisations
          </CNavLink>
        </CNavItem>
      </CNav>
      <CTabContent>
        <CTabPane visible={activeTab === 0}>
          <UpdateDiscount />
        </CTabPane>
        <CTabPane visible={activeTab === 1}>
          <div className="bg-white p-3 rounded-md">
            <UsageDetails />
          </div>
        </CTabPane>
      </CTabContent>
    </div>
  );
}
